import x from "./ForgetPassword";
export default x;
